export default async function handleDownloadFile(response: Response) {
    if (response.status === 200) {
        const disposition = response.headers.get('content-disposition');
        let filename = 'downloaded_file';
        if (disposition) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '');
            }
        }
        const payload = await response.blob();
        const url = URL.createObjectURL(payload);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
    } else {
        try {
            // Prova a leggere il corpo della risposta come JSON o testo
            const errorData = await response.clone().json()
                .catch(async () => {
                    // Se non è JSON, prova a leggerlo come testo
                    return {message: await response.text()};
                });

            console.error('Download error - status:', response.status, 'message:', errorData);
            return {error: true, status: response.status, message: errorData};
        } catch (error) {
            console.error('Download error - status:', response.status, 'Failed to parse error response');
            return {error: true, status: response.status, message: 'Errore durante il download del file'};
        }
    }
}